import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Typography } from '@mui/material';
import TestimonialCard from './TestmonialCards';
import './TestmonialCarousel.css';

import screenshotNvida from '../asset/testimonial_screenshots/nvida.jpg';
import screenshotMsft from '../asset/testimonial_screenshots/msft.jpg';
import screenshotMeta from '../asset/testimonial_screenshots/meta.jpg';
import screenshotJpm from '../asset/testimonial_screenshots/jpm.jpg';
import screenshotBoa from '../asset/testimonial_screenshots/boa.jpg';
import screenshotAdobeIndia from '../asset/testimonial_screenshots/adobe_india.jpg';
import screenshotEmailAce from '../asset/testimonial_screenshots/email_ace.jpg';
import screenshotEmailUbr from '../asset/testimonial_screenshots/email_ubr.jpg';

const TestimonialCarousel = ({ variant = 'default' }) => {
  const [items, setItems] = useState([]);
  const containerRef = useRef(null);
  const [dynamicInterviews, setDynamicInterviews] = useState(19500);
  const [isMobile, setIsMobile] = useState(false);

  const initialTestimonials = useMemo(
    () => [
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: 'Just landed an Adobe offer.',
        screenshot: screenshotAdobeIndia,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: 'Finally got the Microsoft offer.',
        screenshot: screenshotMsft,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: 'Cracked it and got a Meta offer.',
        screenshot: screenshotMeta,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: 'Just signed my JPMorgan offer.',
        screenshot: screenshotJpm,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: 'Landed a Bank of America offer—so relieved.',
        screenshot: screenshotBoa,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: 'Got the NVIDIA offer—dream come true.',
        screenshot: screenshotNvida,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: variant === 'assistant' ? 'Aced the session—offer secured.' : 'Aced the interview—offer secured.',
        screenshot: screenshotEmailAce,
      },
      {
        name: 'Anonymous User',
        avatarLetter: 'A',
        brief: variant === 'assistant' ? 'Cracked my Uber technical after 1,000 applications.' : 'Cracked my Uber interview after 1,000 applications.',
        screenshot: screenshotEmailUbr,
      },
    ],
    [variant],
  );

  useEffect(() => {
    const currentDate = new Date();
    const targetDate = new Date('2024-07-19');
    const daysDifference = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24));
    const randomAdjustment_i = 101 * daysDifference;
    const updatedInterviews = 19500 + randomAdjustment_i;
    setDynamicInterviews(updatedInterviews);
  }, []);

  useEffect(() => {
    setItems(initialTestimonials);
  }, [initialTestimonials]);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mq = window.matchMedia('(max-width: 768px)');
    const update = (e) => setIsMobile(e.matches);

    setIsMobile(mq.matches);

    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', update);
      else mq.removeListener(update);
    };
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let scrollAmount = 0;
    const step = 1;

    const scroll = () => {
      scrollAmount += step;
      container.scrollTop = scrollAmount;

      if (scrollAmount >= container.scrollHeight / 2) {
        scrollAmount = 0;
        container.scrollTop = 0;
      }
    };

    const intervalId = setInterval(scroll, 50);

    return () => clearInterval(intervalId);
  }, [items]);

  const { leftColumnItems, rightColumnItems } = useMemo(() => {
    if (isMobile) return { leftColumnItems: items, rightColumnItems: [] };

    const left = [];
    const right = [];
    items.forEach((item, idx) => {
      if (idx % 2 === 0) left.push(item);
      else right.push(item);
    });
    return { leftColumnItems: left, rightColumnItems: right };
  }, [items, isMobile]);

  return (
    <div className="testimonial-carousel">
      <Typography variant="h4" align="center" gutterBottom>
        Success Stories 🚀
      </Typography>
      <Typography variant="h3" align="center" gutterBottom className="interviews-count">
        {dynamicInterviews} {variant === 'assistant' ? 'ACED Sessions 🎓' : 'ACED Interviews 🎓'}
      </Typography>

      <div className="fade-overlay"></div>
      <div ref={containerRef} className="carousel-container">
        <div className="carousel-columns">
          <div className="carousel-column">
            {[...leftColumnItems, ...leftColumnItems].map((testimonial, index) => (
              <div key={`left-${index}`} className="carousel-item">
                <TestimonialCard testimonial={testimonial} />
              </div>
            ))}
          </div>
          <div className="carousel-column">
            {[...rightColumnItems, ...rightColumnItems].map((testimonial, index) => (
              <div key={`right-${index}`} className="carousel-item">
                <TestimonialCard testimonial={testimonial} />
              </div>
            ))}
          </div>
        </div>

      </div>
                      <div className="fade-overlay-bottom"></div>

    </div>
  );
};

export default TestimonialCarousel;
